import { render, staticRenderFns } from "./ExpertToolSafetyPrecautions.vue?vue&type=template&id=60ecf8ad&"
import script from "./ExpertToolSafetyPrecautions.vue?vue&type=script&lang=js&"
export * from "./ExpertToolSafetyPrecautions.vue?vue&type=script&lang=js&"
import style0 from "./ExpertToolSafetyPrecautions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VAlert,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
